@if (vm$ | async; as vm) {
<div class="ready-board">
  <header class="board-header">
    <div class="brand">
      <div class="title">
        <!-- <span>KIDS TERMINAL</span> -->
        <img src="assets/img/logo-dark.png" alt="Eugov" class="brand-logo" />
      </div>
    </div>
    <div class="clock">
      <div class="time">{{ vm.time }}</div>
      <div class="date">{{ vm.date }}</div>
    </div>
  </header>

  <main class="board-main">
    <section class="panel departures">
      <div class="panel-title">STATUS PLECĂRI</div>
      <div class="departures-content" [attr.data-count]="vm.topPickups.length">
        @for (pickup of vm.topPickups; track i; let i = $index) {
        <div class="pickup-card"
          [class.card-ready]="pickup.status === 'READY_PICKUP'"
          [class.card-preparing]="pickup.status === 'PREPARING_PICKUP'">
          <div class="status-band" [ngClass]="{
                  ready: pickup.status === 'READY_PICKUP',
                  preparing: pickup.status === 'PREPARING_PICKUP'
                }">
            <span class="status-label">
              {{ pickup.status === 'READY_PICKUP' ? 'READY PICKUP' : 'PREPARING PICKUP' }}
            </span>
          </div>

          <div class="pickup-name">{{ pickup.childDisplayName }}</div>

          <div class="pickup-status">
            <span class="label">Status:</span>
            <span class="emoji">{{ pickup.status === 'READY_PICKUP' ? '✅' : '🎒' }}</span>
            <span class="text">
              {{ pickup.status === 'READY_PICKUP' ? 'Ready for pick-up' : 'Se pregătește' }}
            </span>
          </div>

          @if (pickup.gate) {
          <div class="pickup-gate">Poartă: {{ pickup.gate }}</div>
          }
        </div>
        }
        @if (!vm.topPickups.length) {
        <div class="empty-state">Momentan nu sunt plecări în curs</div>
        }
      </div>
    </section>

    <section class="panel announcements">
      <div class="panel-title">ANUNȚURI IMPORTANTE</div>
      <ul class="announcement-list">
        @for (item of vm.state.announcements; track $index) {
        <li [ngClass]="item.type.toLowerCase()">
          <span class="icon" aria-hidden="true"></span>
          <span class="text">{{ item.text }}</span>
        </li>
        }
        @if (!vm.state.announcements.length) {
        <li class="empty">Momentan nu sunt anunțuri.</li>
        }
      </ul>
    </section>

    <section class="panel schedule">
      <div class="panel-title">PROGRAMUL ZILEI</div>
      @if (vm.nextSchedule) {
      <div class="next-up">
        <span class="label">Urmează:</span>
        <span class="value">{{ vm.nextSchedule.time }} — {{ vm.nextSchedule.label }}</span>
      </div>
      } @else {
      <div class="empty">Program în curs de actualizare.</div>
      }
    </section>
  </main>

  <footer class="board-footer">
    <div class="ticker">
      <div class="ticker-track">
        <span>{{ vm.state.tickerText || 'Pentru preluarea copilului, vă rugăm să anunțați personalul!' }}</span>
        <span aria-hidden="true">{{ vm.state.tickerText || 'Pentru preluarea copilului, vă rugăm să anunțați
          personalul!' }}</span>
      </div>
    </div>
    <div class="status-pill" [class.degraded]="vm.connectionIndicator.tone === 'degraded'"
      [class.demo]="vm.connectionIndicator.tone === 'demo'">
      <span class="dot"></span>
      <span class="text">{{ vm.connectionIndicator.label }}</span>
    </div>
  </footer>
</div>
}